export function notNull<TValue>(value: TValue | null | undefined): value is TValue {
    return value != null;
}

export const NotNull = notNull;
export const NonNull = notNull;
